import { useCallback, useEffect, useState } from 'react'
import { withStyles } from '@aura/components/styles'
import { Box, Button, Container, Grid, Typography, Radio } from '@aura/components'
import SmsIcon from '@mui/icons-material/Sms'
import CallIcon from '@mui/icons-material/Call'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import CustomLoader from '../../../../components/custom-loader'
import AccountRecoveryTypes from '../../../../constants/factor-types'
import RegistrationContainer from '../../../../components/new-registration-container'
import { formatPhoneNumberWithSymbol } from '../../../../utils/formatNumber'
import sanitize from '../../../../utils/sanitize'
import styles from './styles'


const Component = ({
    classes,
    userData,
    getAccountRecovery,
    accountRecoveryData,
    onSelectType
}) => {
    const { i18n, t: translate } = useTranslation()
    // const [ hoveredType, setHoveredType ] = useState(null)
    const [ selectedLanguage, setSelectedLanguage ] = useState(i18n.language)
    const [ selectedType, setSelectedType ] = useState(null)


    const title = translate('verificationMethod')
    const verbiage = <div dangerouslySetInnerHTML={{ __html: sanitize(translate('verificationDevType')) }} />

    useEffect(() => {
        if (userData && userData.oktaUserId) {
            getAccountRecovery({ oktaUserId: userData.oktaUserId })
        }
    }, [ userData ])

    useEffect(() => {
        if (accountRecoveryData && accountRecoveryData.length > 0) {
            setSelectedType(accountRecoveryData[0].type)
        }
    }, [ accountRecoveryData ])

    useEffect(() => {
        setSelectedLanguage(i18n.language)
    }, [ i18n.language ])

    const footerContent = (
        <Grid className={classes.buttonContainer}>
            <Button
                className={`${classes.nextButton} ${selectedType === null ? classes.nextButtonDisabled : ''}`}
                color='primary'
                disabled={selectedType === null}
                onClick={useCallback(() => onSelectType(selectedType))}>
                {translate('next')}
            </Button>
        </Grid>
    )

    const mainContent = (
        accountRecoveryData && !accountRecoveryData.length ? (
            <Container className={classes.customLoader}>
                <CustomLoader
                    label={translate('loading')}
                />
            </Container>
            
        ) : (
            <>
                <div className={classes.introText}>
                    <p className={`${classes.subTitle} ${classes.newLine}`}>{translate('registrationFlow.recoveryTitle')}</p>
                </div>
                <div className={`${classes.cardsContainer} ${accountRecoveryData.length === 1 ? classes.cardsContainerOne : ''}`}>
                    {Array.isArray(accountRecoveryData) && accountRecoveryData.map((item, idx) => (
                        <Box
                            key={idx}
                            className={`${classes.accountRecoveryOption} 
                                    ${selectedType === item.type && classes.accountRecoveryOptionSelected}`
                            }

                            onClick={() => handleSelect(item.type)}
                        >
                            <Box className={classes.accountRecoveryInfo}>
                                {item.type === AccountRecoveryTypes.SMS
                                    ? <SmsIcon className={`${classes.accountRecoveryIcon}`} />
                                    : item.type === AccountRecoveryTypes.CALL
                                        ? <CallIcon className={`${classes.accountRecoveryIcon}`} />
                                        : null
                                }
                                <Typography className={`${classes.accountRecoveryType}`}>{translate(item.type)}</Typography>
                                <Typography className={`${classes.accountRecoveryPhoneNumber}`}>{formatPhoneNumberWithSymbol(item, ' ')}</Typography>
                            </Box>
                            <Radio checked={selectedType === item.type} className={classes.radio} />
                        </Box>
                    ))}
                </div>
                <div className={classes.helpText}>
                    <p className={classes.subTitle}>{translate('registrationFlow.helpText')}</p>
                </div>
            </>
        )
    )

    const handleSelect = useCallback(type => {
        setSelectedType(type)
    }, [ onSelectType ])

    return (
        <RegistrationContainer {...{ footerActions : accountRecoveryData.length ? footerContent : null, mainContent, title , verbiage }}>
        </RegistrationContainer>
    )
}

Component.displayName = 'RecoverySelection'

Component.propTypes = {
    accountRecoveryData: PropTypes.array,
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object
    }),
    onNext: PropTypes.func.isRequired,
    onSelectType: PropTypes.func
}

export default withStyles(Component, styles)
